import { TechnicalError } from '../../models/errors.model';
import { SuccessCode, SuccessInfo } from '../../models/success.model';
import * as ChangePasswordActions from '../actions/change-password.actions';

export interface PasswordState {
  error: TechnicalError;
  success: SuccessInfo;
}

export const initialState: PasswordState = {
  error: null,
  success: null,
};

export function reducer(
  state = initialState,
  action: ChangePasswordActions.Actions,
): PasswordState {
  switch (action.type) {
    case ChangePasswordActions.ActionTypes.SUCCESS:
      return changePasswordSuccess(state, action);
    case ChangePasswordActions.ActionTypes.ERROR:
      return changePasswordError(state, action);
    case ChangePasswordActions.ActionTypes.RESET_SUCCESS:
      return resetSuccess(state, action);
    case ChangePasswordActions.ActionTypes.RESET_ERROR:
      return resetError(state, action);
    default:
      return state;
  }
}

function changePasswordSuccess(
  state: PasswordState,
  action: ChangePasswordActions.Actions,
): PasswordState {
  return {
    success: {
      code: SuccessCode.PasswordChangeSuccess,
    },
    error: null,
  };
}

function changePasswordError(
  state: PasswordState,
  action: ChangePasswordActions.Actions,
): PasswordState {
  return {
    success: null,
    error: action.payload,
  };
}

function resetSuccess(
  state: PasswordState,
  action: ChangePasswordActions.Actions,
): PasswordState {
  return {
    ...state,
    success: null,
  };
}

function resetError(
  state: PasswordState,
  action: ChangePasswordActions.Actions,
): PasswordState {
  return {
    ...state,
    error: null,
  };
}

export const getChangePasswordSuccess = (state: PasswordState) => state.success;
export const getChangePasswordError = (state: PasswordState) => state.error;
